<template>
  <v-row>
    <v-col cols="12">
      <div class="d-flex align-center">
        <p class="font-weight-medium mr-3 mb-3">MQTech Packages</p>
        <v-divider />
      </div>
    </v-col>
    <v-row class="pa-0 ma-1" dark>
      <v-col class="mb-20" cols="12">
        <v-row class="justify-center">
          <v-col>
            <v-sheet class="mx-auto" dark elevation="8">
              <carousel-3d
                ref="mycarousel"
                :autoplay="true"
                :autoplay-timeout="5000"
                :controls-visible="true"
                :count="availablePackages.length"
                :display="availablePackages.length"
                @after-slide-change="onAfterSlideChange"
              >
                <slide
                  v-for="(slide, i) in availablePackages"
                  :key="i"
                  :index="i"
                  @click="processSelection(slide)"
                  @onMainSlideClick="processSelection"
                >
                  <figure>
                    <v-img v-reload-on-fail :src="slide.img" />
                    <figcaption>
                      <span class="text-h6">{{ slide.label }}</span>
                      <p>{{ slide.group }}</p>
                      <p>MC: {{ slide.MMC }}</p>
                      <p>QC: {{ slide.MQC }}</p>
                    </figcaption>
                  </figure>
                </slide>
              </carousel-3d>
            </v-sheet>
          </v-col>
          <v-col v-if="selectedPackage" cols="12" dark>
            <v-fade-transition>
              <v-card dark height="200">
                <v-card-title>Package: {{ selectedPackage.label }}</v-card-title>
                <v-card-text>
                  {{ selectedPackage.price }}
                </v-card-text>
                <v-card-text>MC: {{ selectedPackage.MMC }} QC: {{ selectedPackage.MQC }}</v-card-text>
                <v-card-actions>
                  <v-btn @click="purchase(selectedPackage)">Buy Now!</v-btn>
                </v-card-actions>
              </v-card>
            </v-fade-transition>
          </v-col>
          <v-col v-if="!selectedPackage" cols="12">
            <v-card dark height="200">
              <v-card-title>Select a package!</v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
  export default {
    data() {
      return {
        search: '',
        selectedPackage: '',
        model: null,
        firstname: '',
        lastname: '',
        address: '',
        city: '',
        sitecontactnumber: '',
        dateofbirth: '',
        displayName: '',
        country: ' ',
        headers: [
          { text: 'date', align: 'start', sortable: false, value: 'date' },

          {
            text: 'time',
            align: 'start',
            sortable: false,
            value: 'formattime',
          },
          { text: 'gameid', value: 'gameid' },
          { text: 'roundid', value: 'roundid' },
          { text: 'amountplay', value: 'amountplay' },
          { text: 'balance', value: 'balance' },
        ],
      };
    },
    computed: {
      availablePackages() {
        return this.$store.getters.getPackages;
      },
      playerInfo() {
        return this.$store.getters.getPlayerInfo;
      },
    },

    methods: {
      /**
       * @param item
       */
      processSelection() {
        // process the selection
      },
      onAfterSlideChange(index) {
        this.selectedPackage = this.availablePackages[index];
      },
      /**
       * @param selectedPackage
       */
      purchase() {
        // process the purchase
      },
    },
  };
</script>
